// src/pages/MotorcycleForm/components/RangeCell.jsx
import { useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { formatTierLabel } from "../utils/tiers";

export default function RangeCell({ range, idx, isLast, onChangeEnd }) {
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState("");
    const inputRef = useRef(null);

    useEffect(() => {
        if (!editing) return;
        setDraft(String(range.end ?? ""));
        setTimeout(() => inputRef.current?.focus(), 0);
    }, [editing, range.end]);

    const commit = () => {
        const v = Number(draft);
        if (!Number.isFinite(v)) {
            setEditing(false);
            return;
        }
        onChangeEnd(idx, v);
        setEditing(false);
    };

    const cancel = () => {
        setEditing(false);
        setDraft(String(range.end ?? ""));
    };

    return (
        <div className="tier-range">
            {!editing ? (
                <>
                    <span className={`tier-badge ${isLast ? "tier-badge-last" : ""}`}>
                        {formatTierLabel(range.start, range.end)}
                    </span>

                    {isLast ? (
                        <span className="tier-hint">Longer rentals</span>
                    ) : (
                        <Button
                            variant="link"
                            className="tier-edit"
                            onClick={() => setEditing(true)}
                            aria-label="Edit tier end day"
                        >
                            ✏️
                        </Button>
                    )}
                </>
            ) : (
                <div className="tier-edit-wrap">
                    <InputGroup size="sm" className="tier-edit-input">
                        <InputGroup.Text>Up to</InputGroup.Text>
                        <Form.Control
                            ref={inputRef}
                            type="text"
                            inputMode="numeric"
                            value={draft}
                            onChange={(e) => setDraft(e.target.value.replace(/[^\d]/g, ""))}
                            onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                    e.preventDefault();
                                    cancel();
                                } else if (e.key === "Enter") {
                                    e.preventDefault();
                                    commit();
                                }
                            }}
                            onBlur={commit}
                        />
                        <InputGroup.Text>days</InputGroup.Text>
                    </InputGroup>

                    <Button
                        size="sm"
                        variant="outline-secondary"
                        className="tier-edit-cancel"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={cancel}
                    >
                        Cancel
                    </Button>
                </div>
            )}
        </div>
    );
}
